import { render, staticRenderFns } from "./TextDivider.vue?vue&type=template&id=ff2c3938&scoped=true&"
import script from "./TextDivider.vue?vue&type=script&lang=js&"
export * from "./TextDivider.vue?vue&type=script&lang=js&"
import style0 from "./TextDivider.vue?vue&type=style&index=0&id=ff2c3938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2c3938",
  null
  
)

export default component.exports